import {BaseLS} from './BaseLS';
import {IEnum} from '../../../@types/enum';

const STORAGE_KEY = 'videoCodec';

export class VideoCodec extends BaseLS<IEnum> {
  constructor() {
    super(STORAGE_KEY);
  }
}
